import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../../styles/pokemon.module.scss';
import { TProduct, TShoppingCart, TSize } from '../../constants/types';
import PulseLabel from '../../components/pulseLabelComponent';
import { AlertButtonComponent } from '../../components/alertButtonComponent';
import ImageViewerSplashContext from '../../_contexts/ImageViewerContext';
import GlobalContext from '../../_contexts/GlobalContext';

export interface IPokemonCardsProps {
    card: TProduct;
    onBuyClick: Function;
    animationsEnabled: boolean;
    eurprice: number;
    hideSwipe: boolean;
    SetSelectedProductForAlert?: Function;
    AlertCoachmarkVisible: boolean;
    shoppingkart: TShoppingCart;
}

const PokemonCardFC : React.FunctionComponent<IPokemonCardsProps> = (props : IPokemonCardsProps) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
    const [startSwipe, setStartSwipe] = useState<number>(-1);
    const [endSwipe, setEndSwipe] = useState<number>(-1);
    const [added, setAdded] = useState<boolean>(false);
    const [notAdded, setNotAdded] = useState<boolean>(false);
    const [shimmerStyle, setShimmerStyle] = useState<string>("");
    const [ammountInKart, setammountInKart] = useState<number>(0);

    const { setImgUrl } = useContext(ImageViewerSplashContext);
    const { SetToastMessage, Strings, AnimationsEnabled } = useContext(GlobalContext);

    const card = props.card;

    useEffect(() => {
        if (AnimationsEnabled && card.priceInUSD > 5) {
            const r = Math.floor(Math.random() * 4);
            setShimmerStyle(styles[`cardshimmer${r}`]);
        } else {
            setShimmerStyle("");
        }
    },[AnimationsEnabled]);

    useEffect(() => {
        props.shoppingkart.items.forEach((item) => {
            if (item.product.id === card.id) {
                setammountInKart(item.ammount);
            }
        });
    },[props]);

    function swipeEnd(e) {
        if (startSwipe != -1 && endSwipe != -1) {
            if ((endSwipe - startSwipe) > 20) {
                selectedImageIndex > 0 ? setSelectedImageIndex(this.state.selectedImageIdex-1) : setSelectedImageIndex(this.props.card.imageUrls.length -1);
            } else if ((startSwipe - endSwipe) > 20) {
                selectedImageIndex+1 < props.card.imageUrls.length ? setSelectedImageIndex(selectedImageIndex+1) : setSelectedImageIndex(0);
            }
            setStartSwipe(-1);
            setEndSwipe(-1);
        }
    }

    function tryAddToChart(card:TProduct) {
        let done = false;
        if (card.available > 0) {
            done = props.onBuyClick(card); 
        }
        if (done) {
            setAdded(true);
            setTimeout(() => {
                setAdded(false);
            }, 500);
        } else {
            SetToastMessage("Niet meer beschikbaar");
            setNotAdded(true);
            setTimeout(() => {
                setNotAdded(false);
            }, 500);
        }
    }

    return (
        <Stack className={styles.card}>
            <Stack>
                <Stack horizontal>
                    <div className={`${styles.cardTitleContainer}`}>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='start'>
                            </Stack>
                            <Stack horizontal horizontalAlign='end' className={styles.cardHeaderBanner}>
                                {card.available === 0 && <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.soldOut,
                                        src: process.env.PUBLIC_URL + `/assets/soldout.webp`,
                                        styles: props => ({ root: { margin: 0, marginTop:-15, zIndex: 1} }),
                                    }} alt="" />}
                            </Stack>
                        </Stack>
                    </div>
                </Stack>
                <Stack horizontal verticalAlign='center' horizontalAlign='center' style={{overflow:"hidden"}} onClick={ () => { setImgUrl(card.imageUrls[selectedImageIndex]); }}>
                    <div className={`${styles.cardshine} ${styles.cardCompImg}`}>
                        <Image {...{imageFit: ImageFit.centerContain,
                                    className: styles.cardCompImg,
                                    src: card.imageUrls[selectedImageIndex],
                                    onTouchStart: (e) => { setStartSwipe(e.targetTouches[0].clientX); },
                                    onTouchMove: (e) => { setEndSwipe(e.targetTouches[0].clientX); },
                                    onTouchEnd: swipeEnd,
                                    onError: ( e ) => { e.currentTarget.onerror = null; 
                                                        e.currentTarget.src=`${process.env.PUBLIC_URL}/assets/NoImgFound.webp`},
                                    styles: props => ({ root: { margin: 0, cursor: "pointer", backgroundColor: "transparent" } }),
                                }} alt="" />
                        <div className={shimmerStyle}></div>
                    </div>
                    {/* {card.imageUrls.length > 1 && //only show swipe when there are multiple images
                        <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.swipe,
                                        width: 80,
                                        height: 80,
                                        src: process.env.PUBLIC_URL + `/assets/swipe.gif`,
                                        styles: props => ({ root: { margin: 0, zIndex: 1, visibility: swipeHidden ? "hidden" : "visible" } }),
                                    }} alt="" />} */}
                </Stack>
                {props.hideSwipe &&
                <Stack horizontalAlign='center' horizontal verticalAlign='center'>
                    <FontIcon aria-label="Vorige" className={styles.prevNextIcon} onClick={() => {selectedImageIndex > 0 ? setSelectedImageIndex(selectedImageIndex-1) : setSelectedImageIndex(card.imageUrls.length -1)}} iconName="ChevronLeft" />
                    {selectedImageIndex+1} / {card.imageUrls.length} 
                    <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {selectedImageIndex+1 < card.imageUrls.length ? setSelectedImageIndex(selectedImageIndex+1) : setSelectedImageIndex(0)}} iconName="ChevronRight" />
                </Stack>}
                <Stack className={styles.cardInfo}>
                    <Stack horizontal horizontalAlign='center'>
                        <Stack horizontal horizontalAlign='center' style={{maxWidth:"100%", display:"inline-block"}}>
                            <Label className={`${styles.cardnameLabel} ${styles.rarityLabel} ${styles.generalLabel}`}>{card.title}</Label>
                        </Stack>
                    </Stack>
                    <Stack horizontal>
                        <Stack horizontal horizontalAlign='start' style={{maxWidth:"100%", display:"inline-block"}}>
                            <Label className={`${styles.rarityLabel} ${styles.generalLabel}`}>{card.rarety}</Label>
                        </Stack>
                        <Stack horizontal horizontalAlign='end'>
                            <Label className={styles.generalLabel}>{card.scardnumber}</Label>
                        </Stack>
                    </Stack>
                    <hr className={styles.cardInfohr} />
                    <Stack horizontal horizontalAlign='space-between'>
                        <Stack horizontal horizontalAlign='end'>
                            <Label className={styles.generalLabel}>{Strings.Version}:</Label>
                        </Stack>
                        <Stack horizontal horizontalAlign='end'>
                            <Label className={styles.generalLabel}>{card.version}</Label>
                        </Stack>
                    </Stack>
                    <Stack horizontal horizontalAlign='space-between'>
                        <Stack horizontal horizontalAlign='end'>
                            <Label className={styles.generalLabel}>Set:</Label>
                        </Stack>
                        <Stack horizontal horizontalAlign='end'>
                            <Label className={styles.generalLabel}>{card.name}</Label>
                        </Stack>
                    </Stack>
                    <hr className={styles.cardInfohr} />
                    <Stack horizontal horizontalAlign='space-between'>
                        <Stack verticalAlign='center'>
                            <PulseLabel style={{fontSize:"normal!important",fontWeight:"bold"}} text={`€ ${card.priceInUSD === 0 ? "-" : parseFloat((card.priceInUSD * props.eurprice).toString()).toFixed(2)}`} />
                        </Stack>
                        <Stack horizontal horizontalAlign='end' className={styles.butButtonDiv} style={{height:"100%"}}>
                            {card.priceInUSD != 0 && card.available - ammountInKart > 0 ?
                                <FontIcon style={{width:90, maxHeight:"90%", verticalAlign:"middle", fontSize:25, backgroundColor:"#30a7d7"}} 
                                          aria-label={Strings.AddToCart} onClick={() => {tryAddToChart(card);}} 
                                          className={`${styles.buyButton} ${added ? styles.added : notAdded ? styles.notAdded : ""}`} 
                                          iconName={added ? "ShoppingCartSolid" : "ShoppingCart"} />
                                :
                                <AlertButtonComponent Visible={props.AlertCoachmarkVisible} OnClick={() => { props.SetSelectedProductForAlert(card); }} />
                            }
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack> 
    );
}

export default PokemonCardFC;